import { render } from "./HomeSection2.vue?vue&type=template&id=6ff98f76&scoped=true"
import script from "./HomeSection2.vue?vue&type=script&lang=js"
export * from "./HomeSection2.vue?vue&type=script&lang=js"

import "./HomeSection2.vue?vue&type=style&index=0&id=6ff98f76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff98f76"]])

export default __exports__